module.exports = __webpack_public_path__ + "img/ca.166a48c4.svg";